import { render } from "./ToldAboutUs.vue?vue&type=template&id=1402ea5c"
import script from "./ToldAboutUs.vue?vue&type=script&lang=js"
export * from "./ToldAboutUs.vue?vue&type=script&lang=js"

import "./ToldAboutUs.vue?vue&type=style&index=0&id=1402ea5c&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__